import { QuestionEntity } from '../../api/@types'
import { Gender, ReceiptSupplier } from './receipt'

export enum PublicationStatus {
  PUBLIC = 'public',
  PRIVATE = 'private',
  END = 'end',
}

export const publicationsStatus = Object.values(PublicationStatus).map(
  value => {
    return {
      text:
        value === PublicationStatus.PUBLIC
          ? '公開'
          : value === PublicationStatus.PRIVATE
          ? '非公開'
          : '終了',
      value,
    }
  },
)

export const publicationName = (status: PublicationStatus): string => {
  switch (status) {
    case PublicationStatus.END:
      return '終了'
    case PublicationStatus.PRIVATE:
      return '非公開'
    case PublicationStatus.PUBLIC:
      return '公開'
    default:
      return ''
  }
}

export enum QuestionType {
  TEXT = 'text',
  TEXT_AREA = 'textArea',
  NUMBER = 'number',
  DATE = 'date',
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
  CROSS_RADIO = 'crossRadio',
  CROSS_CHECKBOX = 'crossCheckbox',
  FILE = 'file',
}

export const questionTypeName = (type: QuestionEntity['type']): string => {
  switch (type) {
    case QuestionType.TEXT:
      return 'テキスト'
    case QuestionType.TEXT_AREA:
      return 'テキストエリア'
    case QuestionType.NUMBER:
      return '数値'
    case QuestionType.DATE:
      return '日付'
    case QuestionType.RADIO:
      return 'ラジオボタン'
    case QuestionType.CHECKBOX:
      return 'チェックボックス'
    case QuestionType.CROSS_RADIO:
      return 'クロス:ラジオボタン'
    case QuestionType.CROSS_CHECKBOX:
      return 'クロス:チェックボックス'
    case QuestionType.FILE:
      return 'ファイル'
    default:
      return ''
  }
}

export const questionTypes = Object.values(QuestionType).map(value => ({
  text: questionTypeName(value),
  value,
}))

export interface IQuestionnaire {
  id: number
  name: string
  status: PublicationStatus
  releaseAt: Date | null
  releasedAt: Date | null
  finishAt: Date | null
  finishedAt: Date | null
  publicTime: string | null
  comment: string
  description: string
  isRequiredCheck: boolean
  rewardPoint: number
  totalLimitDisplay: number | null
  totalLimit: number | null
  resetLimit: number | null
  pobCategoryId: number | null
  dailyUpperLimitByJan: number | null
  chainStoreId: number | null
  dailyUpperLimitByChain: number | null
  dailyUpperLimit: number | null
  answerUpperLimit: number | null
  image: string | null
  image2: string | null
  image3: string | null
  targetSupplier: ReceiptSupplier
  targetGender: Gender
  targetUpperLimitAge: number | null
  targetLowerLimitAge: number | null
  targetPrefecture: string[]
  targetMarriage: string | null
  createdAt: Date
  updatedAt: Date
  deletedAt: Date | null
  pages: IPage[]

  // not from db
  total: number | null
  totalAnswered: number | null
  totalChecked: number | null
  totalAdminChecked: number | null
}

export interface IPage {
  id: number
  sentence: string
  htmlContent: string
  order: number
  questionnaireId: number
  questions: IQuestion[]
  isThankPage: boolean
}

export interface IQuestion {
  id: number
  type: QuestionType
  questionText: string
  annotationText: string
  copyHistory: string
  isRequiredAnswer: boolean
  isRandom: boolean
  htmlContent: string | null
  pageId: number
  order: number
  // conditions: ConditionEntity[];
  crosses: ICross[]
  choices: IChoice[]
}

export interface IChoice {
  id: number
  name: string
  questionId: number
}

export interface ICross {
  id: number
  name: string
  questionId: number
}

export interface GetQuestionnaireQuery {
  id?: number | null
  name?: string | null
  supplier?: ReceiptSupplier | null
  releaseAt?: Date | null
  finishAt?: Date | null
  status?: PublicationStatus | null
  isAutomatic: boolean | null
}

export interface CreateQuestionnairePage {
  sentence: string | null
  htmlContent: string | null
  order?: number | null
  questionnaireId: number
}

export interface UpdateQuestionnairePage {
  sentence?: string | null
  htmlContent?: string | null
  order?: number | null
}

export interface CreateQuestion {
  type: QuestionType
  questionText: string
  annotationText: string
  copyHistor?: string | null
  isRequiredAnswer: boolean
  isRandom: boolean
  htmlContent?: string | null
  choices?: CreateChoice[] | null
  crosses?: CreateCross[] | null
  pageId: number
  order?: number | null
}

export interface UpdateQuestion {
  type?: QuestionType | null
  questionText?: string | null
  annotationText?: string | null
  copyHistory?: string | null
  isRequiredAnswer?: boolean | null
  isRamdom?: boolean | null
  htmlContent?: string | null
  choices?: CreateChoice[] | null
  crosses?: CreateCross[] | null
  order?: number | null
}

export type CreateChoice = {
  name: string
  questionId: number
}

export type CreateCross = CreateChoice

export enum NgReason {
  UNRELATED_ITEMS = '対象外商品の回答が含まれておりました。',
  UNRELATED_OTHERS = '設問内容と関連のない回答が含まれておりました。',
  COMPLAINT = 'フリーコメントに不満が確認されました。',
  REPEATED = '同じ内容の回答が繰り返し確認されました。',
  OTHERS = 'その他',
}
